if (!window.customElements.get('image-overlay-banner')) {
  window.customElements.define(
    'image-overlay-banner',
    class ImageOverlayBanner extends HTMLElement {
      connectedCallback() {
        if (
          !window.matchMedia('(prefers-reduced-motion: no-preference)').matches ||
          this.getAttribute('reveal-on-scroll') !== 'true'
        ) {
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
              this.observer.disconnect();
              this.reveal();
            }
          },
          { threshold: 0.05 }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      async reveal() {
        const image = this.querySelector('.image-overlay-banner__image');
        const content = this.querySelector('.image-overlay-banner__content');

        if (image instanceof HTMLImageElement && !image.complete) {
          await new Promise((resolve) => {
            image.addEventListener('load', resolve, { once: true });
            image.addEventListener('error', resolve, { once: true });
          });
        }

        this.style.opacity = '1';

        image?.animate(
          [
            { opacity: 0, transform: 'scale(1.1)' },
            { opacity: 1, transform: 'scale(1)' },
          ],
          { duration: 800, easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)', fill: 'forwards' }
        );

        content?.animate([{ opacity: 0 }, { opacity: 1 }], {
          duration: 800,
          delay: 800,
          easing: 'ease',
          fill: 'both',
        });
      }
    }
  );
}
